import { Directive, Input, TemplateRef, ViewContainerRef, OnInit } from '@angular/core';
import { Role } from '../models/user';
import { AuthenticationService } from '../services/authentication.service';

@Directive({
  selector: '[appUserRole]'
})
export class AppUserRoleDirective implements OnInit{

  userRoles: Role[];
  
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private authenticationService:AuthenticationService
  ) { }

  @Input()
  set appUserRole(roles: Role[]){
    
      if (!roles || !roles.length) {
        throw new Error('Roles value is empty or missed');
      }

    this.userRoles = roles;
  }

  ngOnInit() {
    let hasAccess = false;

    if (this.authenticationService.hasRole() && this.userRoles) {
         let rolefinded = this.userRoles.filter(r => r == this.authenticationService.hasRole());
         if(rolefinded.length > 0)
          hasAccess =true 
    }

    if (hasAccess) {
        this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
        this.viewContainer.clear();
    }
}

}
